import { ChangeDetectorRef, inject, Pipe, PipeTransform } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { TranslationService } from "@ogs-gmbh/ngx-translate";
import { TIME_TYPES, TimePeriod } from "@shared/types/period.type";
import { isEqual } from "es-toolkit";
import { distinctUntilChanged, filter, of, Subject, switchMap, tap } from "rxjs";

@Pipe({
  name: "appTimePeriod",
  standalone: true,
  pure: false
})
export class TimePeriodPipe implements PipeTransform {
  private readonly _changeDetectorRef: ChangeDetectorRef = inject(ChangeDetectorRef);

  private readonly _translationService: TranslationService = inject(TranslationService);

  private readonly _timePeriod: Subject<TimePeriod | undefined> = new Subject<TimePeriod | undefined>();


  private _latestValue: string = "";

  constructor () {
    this._timePeriod.pipe(
      takeUntilDestroyed(),
      filter(Boolean),
      distinctUntilChanged(isEqual),
      switchMap((timePeriod: TimePeriod) => {
        if (timePeriod.type === TIME_TYPES.timespan)
          return of(`${ timePeriod.startTime.toIsoTimeString() } - ${ timePeriod.endTime.toIsoTimeString() }`);

        return this._translationService.translateTokenByCurrentLocale$(
          "label-all-day",
          "Durchgehend (24h)",
          "shared/time-period"
        );
      }),
      tap((value: string) => this._updateLatestValue(value))
    ).subscribe();
  }

  public transform (value: TimePeriod | undefined): string {
    this._timePeriod.next(value);

    return this._latestValue;
  }


  private _updateLatestValue (transformedValue: string): void {
    if (transformedValue === this._latestValue)
      return;

    this._latestValue = transformedValue;
    this._changeDetectorRef.markForCheck();
  }
}
